import {RemoteGetPreviewRefunds} from 'data/usecases';
import {GetConsultPreviewRefunds} from 'domain/usecases';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {RefundFlowEndPoints} from 'main/factories/usecases';

export const makeGetConsultPreviewRefunds = (): GetConsultPreviewRefunds =>
	new RemoteGetPreviewRefunds(
		makeBFFApiUrl(RefundFlowEndPoints.consultPreviewRefunds),
		makeAuthorizeHttpClientDecorator(),
	);
